import { createAction } from '@reduxjs/toolkit';

export const resetBookingFlow = createAction('bookingFlow/resetBookingFlow');

export const confirmYourStayReady = createAction('bookingFlow/confirmYourStayReady');
